import React, { useState, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import JsonViewer from 'react-json-view';

import {
  MapContainer,
  TileLayer,
  LayerGroup,
  LayersControl,
  GeoJSON,
  Circle,
  Popup,
  Polyline
} from 'react-leaflet';

import {
  Grid,
  Card,
  CardContent,
  CardHeader,
  Divider
} from '@mui/material';

import { getMission } from 'actions/orderActions';
import { useParams } from 'react-router-dom';
import {
  selectOrderDetails,
} from 'selectors/ordersSelector';
import Page from '../../components/Page/Page';

const { BaseLayer } = LayersControl;

const ShowOrder = props => {
  const params = useParams();
  const [doesStartFinishOverlap, setdoesStartFinishOverlap] = useState(false);
  const [dropIndex, setDropIndex] = useState(0);
  const orderDetails = useSelector(selectOrderDetails);
  const mission = orderDetails?.mission;

  const { requestMission, loading } = props;

  useEffect(() => {
    if (mission && mission.geoJson && mission.geoJson.features) {
      var features = mission.geoJson.features;
      features.forEach((entry, index) => {
        var type = entry.properties.type;
        if (type === 'drop') {
          setDropIndex(index);
        }
      });
      if (
        features[0].geometry.coordinates[0] ===
          features[features.length - 1].geometry.coordinates[0] &&
        features[0].geometry.coordinates[1] ===
          features[features.length - 1].geometry.coordinates[1]
      ) {
        setdoesStartFinishOverlap(true);
      }
    }
  }, [mission]);

  // Requerst Mission
  useEffect(() => {
    if (params) {
      requestMission(params?.id);
    }
  }, [requestMission, params]);

  let initialLocation = null;
  if (mission && mission.geoJson) {
    initialLocation = [
      mission.geoJson.features[0].geometry.coordinates[1],
      mission.geoJson.features[0].geometry.coordinates[0]
    ];
  }

  const getDropPointLatLng = () => {
    let latitude;
    let longitude;
    const dropPoint = mission?.geoJson?.features?.find(f => f?.properties?.type === 'drop');
    longitude = dropPoint.geometry?.coordinates[0];
    latitude = dropPoint.geometry?.coordinates[1];
    return [latitude, longitude]
  }
  let i = 0;
  let j = 0;
  let latLngList = [];

  return (
    <Page style={{padding: '24px'}}>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          {mission && Object.keys(mission).length > 0 && (
            <Card>
              {mission && (
                <CardContent>
                  <MapContainer
                    center={initialLocation}
                    style={{ height: '500px' }}
                    zoom={16}
                    maxZoom={24}>
                    <TileLayer
                      attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <LayersControl>
                      <BaseLayer checked name="Manna v1">
                        <TileLayer
                          attribution="Manna-v1"
                          url="https://tiles.manna.aero/{z}/{x}/{y}.png"
                          maxZoom={24}
                        />
                      </BaseLayer>
                      <BaseLayer name="Manna v2">
                        <TileLayer
                          attribution="Manna-v2"
                          url="https://tiles-dev.manna.aero/{z}/{x}/{y}.png"
                          maxZoom={24}
                        />
                      </BaseLayer>
                    </LayersControl>
                    <LayerGroup>
                      {mission && (
                        <>
                          {/* Path */}
                          <GeoJSON
                            data={JSON.parse(mission.geoJsonLineString)}
                          />
                        </>
                      )}
                    </LayerGroup>

                    <LayerGroup>
                      {mission && (
                        <>
                          {/* Geotunnel */}
                          <GeoJSON
                            data={mission.geoJsonGeotunnel}
                            style={{ color: 'deeppink', border: 0.5 }}
                          />
                        </>
                      )}
                    </LayerGroup>

                    <Polyline positions={latLngList} color={'#000'} />

                    {mission &&
                      mission.flightData &&
                      mission.flightData &&
                      mission.flightData.length > 0 &&
                      mission.flightData.map(entry => {
                        let latitude = 0;
                        let longitude = 0;
                        let altitude = 0;

                        if (entry.latitude) {
                          latitude = entry.latitude;
                          longitude = entry.longitude;
                          altitude = entry.alt;
                        } else if (entry.message) {
                          if (entry.message.fcu1) {
                            if (entry.message.fcu1.gps) {
                              latitude = parseFloat(entry.message.fcu1.gps.lat);
                              longitude = parseFloat(
                                entry.message.fcu1.gps.lon
                              );
                              altitude = parseFloat(
                                entry.message.fcu1.alt.relitive_alt
                              );
                            } else {
                              latitude = parseFloat(entry.message.fcu1.lat);
                              longitude = parseFloat(entry.message.fcu1.lon);
                              altitude = parseFloat(
                                entry.message.fcu1.relitive_alt
                              );
                            }
                          } else {
                            latitude = parseFloat(entry.latitude);
                            longitude = parseFloat(entry.longitude);
                            altitude = parseFloat(entry.alt);
                          }
                        }

                        if (latitude !== 0 && longitude !== 0) {
                          j++;
                          let radiusX = 0.1;
                          let colorX = 'springgreen'; // outbound
                          if (j >= mission.flightData.length) {
                            colorX = 'cyan'; //start
                            radiusX = 0.3;
                          } else if (mission.flightData.length / 2 > j) {
                            colorX = 'yellow'; //inbound
                          }
                          if ((latitude, longitude, altitude)) {
                            return (
                              <Circle
                                center={[latitude, longitude]}
                                radius={radiusX}
                                color={colorX}
                                fillColor={colorX}
                                fillOpacity={1}
                                key={`${altitude} - ${latitude} - ${longitude} - ${i} - ${j}`}
                                onMouseOver={e => {
                                  e.target.openPopup();
                                }}>
                                <Popup>
                                  ALT:{entry.alt}m {entry['flight-mode']}
                                </Popup>
                              </Circle>
                            );
                          }
                        }
                        return null;
                      })}

                    <Circle
                      key={`route-circle-${mission.id}`}
                      center={getDropPointLatLng()}
                      radius={0.2}
                      color={'cyan'}
                      fillColor={'cyan'}
                      fillOpacity={1} >
                    </Circle>

                  </MapContainer>
                </CardContent>
              )}
            </Card>
          )}
        </Grid>
        <Grid item xs={6}>
          <Grid container spacing={3}>
            {mission && (
              <Grid item xs={12}>
                <Card>
                  <CardHeader title="Mission Details" />
                  <Divider />
                  <CardContent>
                    <JsonViewer
                      src={mission}
                      collapsed={1}
                      enableClipboard={false}
                      displayObjectSize={false}
                      displayDataTypes={false}
                      collapseStringsAfterLength={64}
                    />
                  </CardContent>
                </Card>
              </Grid>
            )}
            {mission &&
              mission.flightData &&
              Array.isArray(mission.flightData) &&
              mission.flightData.length > 0 && (
                <Grid item xs={12}>
                  <Card>
                    <CardHeader title="Flight Data" />
                    <Divider />
                    <CardContent>
                      <JsonViewer
                        src={mission.flightData}
                        collapsed={1}
                        enableClipboard={false}
                        displayObjectSize={false}
                        displayDataTypes={false}
                        collapseStringsAfterLength={64}
                      />
                    </CardContent>
                  </Card>
                </Grid>
              )}
          </Grid>
        </Grid>
      </Grid>
    </Page>
  );
};

const mapStateToProps = state => ({
  loading: state.ui.loading
});

const mapDispatchToProps = dispatch => ({
  requestMission: missionId => dispatch(getMission(missionId))
});

ShowOrder.defaultProps = {
  mission: {}
};

export default connect(mapStateToProps, mapDispatchToProps)(ShowOrder);
